import React from 'react';
import T from 'i18n-react';

const CardButton = ({history, onClick, disabled=false, classStyle="btm-cnt-card"}) => (
    <div className={classStyle+" row"}>
        <div className="col-sm-6">
        <button type="button"  className="curr-pointer btn-card-back btn btn-warning"
                onClick={()=> history.push('/topUpEwallet')}>
                  <T.text tag='span' text="back"/>
              </button>
        </div>

        <div className="col-sm-6">
          <button type="button"  className="curr-pointer btn-card-wallet btn btn-warning"
                onClick={() => onClick()} disabled={disabled}>
                  <T.text tag='span' text="menu_top_up_wallet"/>
              </button>
         </div>
    </div>
);
export default CardButton;



// WEBPACK FOOTER //
// ./src/components/prepaidCard/CardButton.js